import {getCookie, removePipes} from "@core-ui/utility";
import {
  getShippingAttributes,
  getBounceBackText,
  hasBounceBack,
  hasRewards,
  getCoordinates,
  getZipCode,
  isMtlMember,
  tierStatus,
} from "./helpers/personalization-adapter-helper";

export const EXTERNAL_CUSTOMER_ID = "cam";

/**
 * Maps relevant stuff for MyAccount from Personalization response,
 * @param rawPersonalizationData JSON from API response
 * @returns {*object} object reflecting Personalization data needed for MyAccount
 * @constructor
 */

export type PersonalizationAdapterType =
  | {
      personalizationInfoV1: any;
      userContext: Record<string, unknown>;
      customerAccount: Record<string, unknown>;
      customerAttributes: Record<string, unknown>;
      featureSelections: Record<string, unknown>;
      shoppingBag: Record<string, unknown>;
      marketingMessageInfo: Record<string, unknown>;
      customerUUID: any;
      customerId: any;
      personalizationReferrerInfo: Record<string, unknown>;
      redpointPersonalizedMarketingData: Record<string, unknown>;
      preScreenResponse: Record<string, unknown>;
      (value: unknown): unknown;
    }
  | {
      (value: unknown): unknown;
      personalizationInfoV1: any;
    };

type BrandCode = 1 | 2 | 3 | 5 | 6;

export const personalizationAdapter =
  (marketAgnosticBrandCode: string | number | BrandCode) =>
  (data: PersonalizationAdapterType) => {
    const {
      userContext = {},
      customerAccount = {},
      customerAttributes = {},
      featureSelections = {},
      shoppingBag = {},
      marketingMessageInfo = {},
      customerUUID,
      customerId,
      personalizationReferrerInfo = {},
      redpointPersonalizedMarketingData = {},
      preScreenResponse = {},
    } = (data || {}).personalizationInfoV1 || {};
    const {mtl_member_status} = isMtlMember(customerAttributes);
    const {tier_status} = tierStatus(customerAttributes);
    const {isLoggedInUser, isRecognizedUser} = userContext;
    const {firstName} = customerAccount || {};
    const geoLocation = marketingMessageInfo?.geoLocation || "";

    const bouncebackActive = hasBounceBack(
      customerAttributes,
      marketAgnosticBrandCode as number
    );
    const rewardsActive = hasRewards(customerAttributes);
    const bouncebackText = getBounceBackText(
      marketAgnosticBrandCode as BrandCode
    );

    return {
      customerId,
      customerUUID,
      externalCustomerId: removePipes(getCookie(EXTERNAL_CUSTOMER_ID)),
      personalizationReferrerInfo: {
        headerReferrerUrl: personalizationReferrerInfo.headerReferrerUrl,
      },
      shoppingBag: {
        totalItemCount: Number(shoppingBag.totalItemCount) || 0,
        totalItemAmount: Number(shoppingBag.totalItemAmount) || 0,
      },
      marketingMessageInfo,
      userContext,
      customerAttributes,
      mtl_member_status,
      tier_status,
      featureSelections,
      firstName,
      isLoggedInUser: isLoggedInUser === "true",
      isRecognizedUser: isRecognizedUser === "true",
      internationalShipping: {
        ...getShippingAttributes(userContext),
      },
      virtualValueInterrupterStatus: {
        bouncebackActive,
        rewardsActive,
        bouncebackText,
        totalRewardValue: parseInt(
          customerAttributes.totalRewardValue || 0,
          10
        ),
        tier: customerAttributes.tier,
        mtlMember: customerAttributes.mtlMember === "true",
      },
      geoCoordinates: getCoordinates(geoLocation),
      // TODO: add support for zipOverride from querystring params
      // to the call to `getZipCode` below
      zipCode: getZipCode(geoLocation, null),
      redpointPersonalizedMarketingData,
      preScreenResponse,
    };
  };
